import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseSignalRService } from './base-signalr.service';

@Injectable({
  providedIn: 'root'
})
export class QuotesSignalRService extends BaseSignalRService {
  private readonly opportunityDeactivatedSubject = new BehaviorSubject<string>('');

  public opportunityDeactivated$ = this.opportunityDeactivatedSubject.asObservable();

  protected getHubUrl(): string {
    return `${this.apiUrl}/deactivatedOpportunityHub`;
  }

  protected setupEventHandlers(): void {
    if (!this.hubConnection) return;

    this.hubConnection.on('OpportunityDeactivated', (opportunityId: string | { value: string; }) => {
      const id = typeof opportunityId === 'string' ? opportunityId : opportunityId.value;
      this.opportunityDeactivatedSubject.next(id);
    });

    this.setupConnectionStateHandlers();
  }
}
